"use client";

import { useState, useEffect, useCallback, useRef } from "react";
import { useSearchParams } from "next/navigation";

export const LAST_LOGIN_PROVIDER_KEY = "meex:last-login-provider";

export const getLastLoginProvider = () => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(LAST_LOGIN_PROVIDER_KEY);
  } catch {
    return null;
  }
};

export const setLastLoginProvider = (provider) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LAST_LOGIN_PROVIDER_KEY, provider);
  } catch {
    // Continue even if browser storage is unavailable.
  }
};

export function useLastLoginProvider() {
  const [lastProvider, setLastProvider] = useState(null);
  const updateTimerRef = useRef(null);
  const searchParams = useSearchParams();

  useEffect(() => {
    setLastProvider(getLastLoginProvider());
    return () => clearTimeout(updateTimerRef.current);
  }, []);

  const rememberProvider = useCallback((provider) => {
    setLastLoginProvider(provider);
    clearTimeout(updateTimerRef.current);
    updateTimerRef.current = setTimeout(() => {
      setLastProvider(provider);
    }, 1000);
  }, []);

  const previewProvider = searchParams?.get("testLastUsed");
  const displayedLastProvider = ["linkedin", "google", "email"].includes(
    previewProvider,
  )
    ? previewProvider
    : lastProvider;

  return {
    lastProvider: displayedLastProvider,
    rememberProvider,
  };
}

export default useLastLoginProvider;
